import {inject, Injectable} from "@angular/core";
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    private matSnackBar = inject(MatSnackBar);


    /**
     * Shows a toast message.
     * @param message The message to show.
     * @param duration The duration to show the message for.
     */
    showSuccess(message: string, duration: number = 5000): void {
        this.matSnackBar.open(message, 'Close', {
            duration: duration,
            panelClass: ['toast-success']
        });
    }

    showError(message: string, duration: number = 5000): void {
        this.matSnackBar.open(message, 'Close', {
            duration: duration,
            panelClass: ['toast-error']
        });
    }

    showInfo(message: string, duration: number = 5000): void {
        this.matSnackBar.open(message, 'Close', {
            duration: duration,
            panelClass: ['toast-info']
        });
    }
}